import * as React from 'react';

const Tariffs = ({ width, height }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    fill='none'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9 2.66699H17C18.1046 2.66699 19 3.56242 19 4.66699V23.3337C19 24.4382 18.1046 25.3337 17 25.3337H9C7.89543 25.3337 7 24.4382 7 23.3337V4.66699C7 3.56242 7.89543 2.66699 9 2.66699ZM5.12602 3.66699C5.57006 1.94176 7.13616 0.666992 9 0.666992H17C18.8638 0.666992 20.4299 1.94176 20.874 3.66699H21C23.7614 3.66699 26 5.90557 26 8.66699V19.3337C26 22.0951 23.7614 24.3337 21 24.3337H20.874C20.4299 26.0589 18.8638 27.3337 17 27.3337H9C7.13616 27.3337 5.57006 26.0589 5.12602 24.3337H5C2.23858 24.3337 0 22.0951 0 19.3337V8.66699C0 5.90557 2.23858 3.66699 5 3.66699H5.12602ZM5 5.66699C3.34315 5.66699 2 7.01014 2 8.66699V19.3337C2 20.9905 3.34315 22.3337 5 22.3337V5.66699ZM21 22.3337C22.6569 22.3337 24 20.9905 24 19.3337V8.66699C24 7.01014 22.6569 5.66699 21 5.66699V22.3337Z'
      fill='#333333'
    />
  </svg>
);

export default Tariffs;
